import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Nav,
} from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import routes from "routes/routes";
import { useDispatch, useSelector } from "react-redux";
import { establecerHuerta } from "store/slices/data/dataSlice";
import { abrirDropdown } from "utils/generalFunctions";

var ps;

function Sidebar() {
  const { user } = useSelector((state) => state.auth);
  const sidebar = React.useRef();
  const dispatch = useDispatch();
  const [squemas] = useState(user?.squemas);

  const { huerta } = useSelector((state) => state.dataApp);
  const { status } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(
    localStorage.getItem("open")
      ? localStorage.getItem("open")
      : abrirDropdown(user)
  );

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  }, []);

  const toggle = (id) => {
    //Saber en qué item del acordeón del menú fué el último que abrió
    localStorage.setItem("open", id);
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const cambiarHuerta = (idHuerta) => {
    dispatch(establecerHuerta(parseInt(idHuerta)));
  };

  return (
    <div className="sidebar border-0">
      {status == "authenticated" && (
        <div className="logo">
          <select
            onChange={(event) => {
              cambiarHuerta(event.target.value);
            }}
            className="w-100 p-3  mt-2 mb-2 rounded"
          >
            {squemas?.map((squema, i) => {
              return i + 1 == huerta ? (
                <option
                  selected
                  className="colorOrange text-dark"
                  key={i}
                  value={squema.id_squema}
                >
                  {squema.nombre_huerta}
                </option>
              ) : (
                <option
                  className="selectoption"
                  key={i}
                  value={squema.id_squema}
                >
                  {squema.nombre_huerta}
                </option>
              );
            })}
          </select>
        </div>
      )}
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {status == "no-authenticated" && (
            <NavLink to={"/login"}>
              <div className="text-white d-flex p-3">
                <span className="mdi mdi-login-variant mr-2 text-white"></span>
                <p className="text-white">Iniciar sesión</p>
              </div>
            </NavLink>
          )}
          <Accordion open={open} toggle={toggle}>
            {routes.map((prop, key) => {
              if (user?.privilegios[prop.permiso]) {
                if (prop.permiso == "estacion_metereologica") {
                  return (
                    <AccordionItem key={key + 1}>
                      {/* Target id espera una cadena y no un número */}
                      <AccordionHeader targetId={key.toString()}>
                        <a
                          className="sinEstilo"
                          target="blank"
                          href="http://www.avantsolar.com/tabernas/weather/"
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="text-white">Estación Meteorológica</p>
                            <i className="mdi mdi-web"></i>
                          </div>
                        </a>
                      </AccordionHeader>
                    </AccordionItem>
                  );
                } else if (prop.permiso == "radar") {
                  return (
                    <AccordionItem key={key + 1}>
                      {/* Target id espera una cadena y no un número */}
                      <AccordionHeader targetId="100">
                        <a
                          className="sinEstilo"
                          target="blank"
                          href="https://www.aemet.es/es/eltiempo/observacion/radar"
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="text-white">Radar</p>
                            <i className="mdi mdi-web"></i>
                          </div>
                        </a>
                      </AccordionHeader>
                    </AccordionItem>
                  );
                } else {
                  return (
                    <div key={key}>
                      <AccordionItem>
                        {/* Target id espera una cadena y no un número */}
                        <AccordionHeader targetId={(key + 1).toString()}>
                          <div className="d-flex justify-content-between align-items-center">
                            <p>{prop.name}</p>
                            <i className="nc-icon nc-minimal-down"></i>
                          </div>
                        </AccordionHeader>
                        <AccordionBody accordionId={(key + 1).toString()}>
                          <ul className="d-flex justify-content-center flex-column align items-center">
                            {prop.subRutas.map((ruta, key) => {
                              return (
                                <NavLink key={key} to={ruta.path}>
                                  <li className="text-light">{ruta.name}</li>
                                </NavLink>
                              );
                            })}
                          </ul>
                        </AccordionBody>
                      </AccordionItem>
                    </div>
                  );
                }
              }
            })}
            {user?.privilegios["zona_cliente"] ||
            status == "no-authenticated" ? (
              <AccordionItem className="helpAccordionItem">
                {/* Target id espera una cadena y no un número */}
                <AccordionHeader targetId={"50"}>
                  <div className="d-flex justify-content-between align-items-center">
                    <p>Ayuda</p>
                    <i className="nc-icon nc-minimal-down"></i>
                  </div>
                </AccordionHeader>
                <AccordionBody accordionId={"50"}>
                  <ul className="d-flex justify-content-center flex-column align items-center">
                    <NavLink className={"text-light"} to={"/sobrenosotros"}>
                      <li>Quienes somos</li>
                    </NavLink>
                    <NavLink className={"text-light"} to={"/seguidores"}>
                      <li>Seguidores</li>
                    </NavLink>
                    <NavLink className={"text-light"} to={"/promociones"}>
                      <li>Promociones</li>
                    </NavLink>
                    <NavLink className={"text-light"} to={"/contacto"}>
                      <li>Contacto</li>
                    </NavLink>
                  </ul>
                </AccordionBody>
              </AccordionItem>
            ) : null}
          </Accordion>
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
